<template>
  <div class="status-badge mr-2" :style="variant">
    <i class="fas mx-1" :class="variant.icon" />
    <span class="mx-1">{{ title }}</span>
  </div>
</template>
<script>
export default {
  name: 'StatusBadge',
  props: {
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'denied',
    },
  },
  data: () => ({
    variants: [
      {
        name: 'success',
        icon: 'fa-check-circle',
        background: '#e7fbf1',
        textColor: '#2db782',
        iconColor: '#2db782',
        borderColor: '#39da8a',
      },
      {
        name: 'denied',
        icon: 'fas fa-times-circle',
        background: '#fbe7e7',
        textColor: '#b72d2d',
        iconColor: '#b72d2d',
        borderColor: '#da3939',
      },
    ],
  }),
  computed: {
    variant() {
      let currentStyle = this.variants.find(
        (variant) => variant.name == this.type
      );

      return {
        icon: currentStyle.icon,
        '--bg-color': currentStyle.background,
        '--text-color': currentStyle.textColor,
        '--icon-color': currentStyle.iconColor,
        '--border-color': currentStyle.borderColor,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.status-badge {
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 19px;
  background-color: var(--bg-color);
  padding: 10px;
  display: inline-block;

  i {
    color: var(--icon-color);
  }
  span {
    font-size: 1em;
    color: var(--text-color);
  }
}
</style>
